var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rs-wrap" }, [
    _c("div", { staticClass: "rs-header" }, [
      _c("span", { staticClass: "rs-header__title" }, [
        _vm._v("Repeat Field Columns")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "rs-header__count" }, [
        _vm._v(
          _vm._s(_vm.inner_fields.length) +
            " column" +
            _vm._s(_vm.inner_fields.length !== 1 ? "s" : "")
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rs-columns" },
      _vm._l(_vm.inner_fields, function(innerfield, i) {
        return _c("div", { key: i, staticClass: "rs-card" }, [
          _c(
            "div",
            {
              staticClass: "rs-card__head",
              on: {
                click: function($event) {
                  return _vm.toggleCollapse(i)
                }
              }
            },
            [
              _c("div", { staticClass: "rs-card__head-left" }, [
                _c("span", { staticClass: "rs-card__index" }, [
                  _vm._v(_vm._s(i + 1))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "rs-card__title" }, [
                  _vm._v(
                    _vm._s(
                      innerfield.field_properties.title || "Untitled column"
                    )
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "rs-card__badge" }, [
                  _vm._v(
                    _vm._s(
                      _vm.available_elements[innerfield.fields] ||
                        innerfield.fields
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "rs-card__head-right",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { content: "Add column", placement: "top" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "rs-icon-btn rs-icon-btn--add",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.add_field($event)
                            }
                          }
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    { attrs: { content: "Remove column", placement: "top" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "rs-icon-btn rs-icon-btn--del",
                          class: {
                            "rs-icon-btn--disabled":
                              _vm.inner_fields.length === 1
                          },
                          attrs: { disabled: _vm.inner_fields.length === 1 },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.delete_field(i)
                            }
                          }
                        },
                        [_c("i", { staticClass: "el-icon-minus" })]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-arrow-down rs-chevron",
                    class: { "rs-chevron--open": !_vm.collapsed[i] }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.collapsed[i],
                  expression: "!collapsed[i]"
                }
              ],
              staticClass: "rs-card__body"
            },
            [
              _c(
                "div",
                { staticClass: "rs-field" },
                [
                  _c("label", { staticClass: "rs-label" }, [
                    _vm._v("Field Type")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "rs-full",
                      attrs: { size: "small" },
                      model: {
                        value: innerfield.fields,
                        callback: function($$v) {
                          _vm.$set(innerfield, "fields", $$v)
                        },
                        expression: "innerfield.fields"
                      }
                    },
                    _vm._l(_vm.available_elements, function(label, key) {
                      return _c("el-option", {
                        key: key,
                        attrs: { value: key, label: label }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rs-field" },
                [
                  _c("label", { staticClass: "rs-label" }, [_vm._v("Label")]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "Column label" },
                    model: {
                      value: innerfield.field_properties.title,
                      callback: function($$v) {
                        _vm.$set(innerfield.field_properties, "title", $$v)
                      },
                      expression: "innerfield.field_properties.title"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rs-field" },
                [
                  _c("label", { staticClass: "rs-label" }, [
                    _vm._v("Placeholder")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "Placeholder text" },
                    model: {
                      value: innerfield.field_properties.placeholder,
                      callback: function($$v) {
                        _vm.$set(
                          innerfield.field_properties,
                          "placeholder",
                          $$v
                        )
                      },
                      expression: "innerfield.field_properties.placeholder"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              innerfield.fields === "form_dropdown_field"
                ? _c(
                    "div",
                    { staticClass: "rs-field" },
                    [
                      _c("label", { staticClass: "rs-label" }, [
                        _vm._v("Options")
                      ]),
                      _vm._v(" "),
                      _c("field_option_data", {
                        attrs: {
                          editfield: innerfield.field_properties,
                          field: innerfield
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              [
                "form_text_field",
                "form_number_field",
                "form_email_address"
              ].includes(innerfield.fields)
                ? _c(
                    "div",
                    { staticClass: "rs-field" },
                    [
                      _c("label", { staticClass: "rs-label" }, [
                        _vm._v("Default value")
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "Default" },
                        model: {
                          value: innerfield.field_properties.default,
                          callback: function($$v) {
                            _vm.$set(
                              innerfield.field_properties,
                              "default",
                              $$v
                            )
                          },
                          expression: "innerfield.field_properties.default"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rs-field rs-field--inline" },
                [
                  _c("label", { staticClass: "rs-label" }, [
                    _vm._v("Required")
                  ]),
                  _vm._v(" "),
                  _c("el-switch", {
                    attrs: {
                      "active-color": "#2563eb",
                      "active-value": true,
                      "inactive-value": false
                    },
                    model: {
                      value: innerfield.field_properties.required,
                      callback: function($$v) {
                        _vm.$set(innerfield.field_properties, "required", $$v)
                      },
                      expression: "innerfield.field_properties.required"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              innerfield.field_properties.required
                ? _c(
                    "div",
                    { staticClass: "rs-field" },
                    [
                      _c("label", { staticClass: "rs-label" }, [
                        _vm._v("Error message")
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "This field is required"
                        },
                        model: {
                          value: innerfield.field_properties.message,
                          callback: function($$v) {
                            _vm.$set(
                              innerfield.field_properties,
                              "message",
                              $$v
                            )
                          },
                          expression: "innerfield.field_properties.message"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "rs-add-btn",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.add_field($event)
          }
        }
      },
      [_c("i", { staticClass: "el-icon-plus" }), _vm._v(" Add Column\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }